import { useQuery } from '@tanstack/react-query';
import { useHistory, useLocation } from 'react-router-dom';
import React, { useMemo } from 'react';
import * as qs from 'qs';
import Spinner from '../../components/layout/Spinner';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import api from '../../domain/api';
import SuperAdminDashboardView from './_components/superadmin-dashboard-view';

const SuperAdminDashboard = () => {
  const history = useHistory();
  const location = useLocation();

  // Parse query parameters
  const queryParams = useMemo(() => {
    return qs.parse(location.search.replace('?', ''));
  }, [location.search]);

  // Fetch optimized super admin dashboard data
  const {
    data: dashboardData,
    isLoading: dashboardLoading,
    refetch: refetchDashboard,
  } = useQuery({
    queryKey: ['superadmin_optimized_dashboard', queryParams],
    queryFn: async () => {
      const query = qs.stringify(queryParams, { encodeValuesOnly: true });
      const resp = await api.get(`/clients/superadmin/dashboard?${query}`);
      return resp.data;
    },
    keepPreviousData: true,
    staleTime: 1000 * 60 * 2,
  });

  // Handle filter changes
  const handleFilterChange = (filters) => {
    const query = qs.stringify(filters, { encodeValuesOnly: true });
    history.push(`${location.pathname}?${query}`);
  };

  const handleBack = () => {
    history.push('/dashboard');
  };

  console.log('dashboardData', dashboardData);

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title='Super Admin Dashboard'
          mainLinkTitle='Dashboard'
          mainLinkUrl='dashboard'
          activeLink='Super Admin Dashboard'
        />

        {!dashboardLoading ? (
          dashboardData && (
            <SuperAdminDashboardView
              dashboardData={dashboardData}
              onFilterChange={handleFilterChange}
              onBack={handleBack}
              onRefresh={refetchDashboard}
              queryParams={queryParams}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
